export const translate = (value) => {
  const translations = {
    fullName: 'Nombre',
    firstName: 'Nombre/s',
    lastName: 'Apellido/s',
    id: 'ID',
    email: 'Email',
    telephone: 'Teléfono',
    address: 'Dirección',
    password: 'Contraseña',
    passwordConfirm: 'Confirmar contraseña',
    accounts: 'Empleados',
    Account: 'Empleado',
    Translator: 'Intérprete',
    translatorId: 'Intérprete',
    translators: 'Intérpretes',
    Mediator: 'Mediador',
    mediatorId: 'Mediador',
    mediators: 'Mediadores',
    Client: 'Cliente',
    clientId: 'Cliente',
    clients: 'Clientes',
    speciality: 'Especialidad',
    allowQR: 'Permitir QR',
    createdAt: 'Creado',
    endedAt: 'Finalizado',
    deletedAt: 'Borrado',
    updatedAt: 'Actualizado',
    translatorFullName: 'Nombre Intérprete',
    translatorEmail: 'Email Puesto',
    accountFullName: 'Nombre Cuenta',
    accountEmail: 'Email Cuenta',
    companyName: 'Empresa',
    medium: 'Medio',
    name: 'Nombre',
    maxAccounts: 'Máximo de cuentas',
    calls: 'Llamadas',
    roomId: 'ID Sala',
    mediatorName: 'Mediador',
    clientName: 'Cliente',
    earliestCall: 'Llamada más temprana',
    latestCall: 'Llamada más tardía',
    callDurationAvg: 'Promedio duración de llamadas',
    callsDayMomentAvg: 'Hora promedio de inicio de llamada',
    callsCount: 'Total de llamadas',
    totalCallsDuration: 'Duración total de llamadas',
    pendingRequests: 'Peticiones Pendientes',
    connected: 'En línea',
    accountsUsed: 'Cuentas en uso',
  }
  return translations[value] || '`Traducción faltante`'
}
